// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"0799b889","239":"b2e982cc","389":"bbc9afd0","453":"de6bdd68","455":"1935ce00","977":"29cbb817"}[chunkId] + ".chunk.js";
};